import { Tooltip } from '@mui/material';
import _isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Select from '@Components/DomElements/Select';
import SelectOption from '@Components/DomElements/SelectOption';
import EntitiesApi from '@Data/entities/Api';
import FoldersApi from '@Data/folders/Api';
import { QualityControlApi } from '@Data/qualityControl/Api';
import WorkbenchesApi from '@Data/workbenches/Api';
import { getAllWorkbenches, getWorkbenchName } from '@Data/workbenches/Helpers';
import { WorkbenchType } from '@Data/workbenches/Interfaces';
import { selectedWorkbenchState } from '@Data/workbenches/Reducer';
import { KoruRoutes } from '@Services/navigation/Paths';

interface IWorkbenchSelectorProps {
    initialWorkbench: WorkbenchType;
    id: string;
}

const WorkbenchSelector = (props: IWorkbenchSelectorProps) => {
    const navigate = useNavigate();
    const { organizationId, teamId, projectId, folderIds } = useParams();

    const selectRef = useRef();
    const selectedWorkbench = useSelector(selectedWorkbenchState);

    useEffect(() => {
        WorkbenchesApi.setWorkbench(props.initialWorkbench);
    }, [props.initialWorkbench]);

    const handleSelectWorkbench = (wb: WorkbenchType) => {
        FoldersApi.clearSelectedState();
        EntitiesApi.clearEntity();
        QualityControlApi.reset();

        WorkbenchesApi.setWorkbench(wb, () => {
            let url;
            switch (wb) {
                case WorkbenchType.QC:
                    url = KoruRoutes.qc.getUrl(
                        organizationId,
                        teamId,
                        projectId,
                        folderIds
                    );
                    break;
            }
            navigate(url);
        });
    };

    const options = getAllWorkbenches().map((wb: WorkbenchType, i) => {
        return (
            <SelectOption
                id={`${props.id}-option-${wb}`}
                key={`wbOpt${wb}`}
                parentRef={selectRef}
                text={getWorkbenchName(wb)}
                onClick={() => handleSelectWorkbench(wb)}
            />
        );
    });

    return (
        <Select
            value={getWorkbenchName(selectedWorkbench)}
            ref={selectRef}
            id={props.id}
            title="Workbench Selector"
        >
            {options}
        </Select>
    );
};

export default WorkbenchSelector;
